// React Lazily
import { lazily } from 'react-lazily'

// Interfaces
import { IRoute } from 'routes/route.interface'

// Constant
import { CONTENT_URL, CONTENT_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { ContentContactUsIndex } = lazily(() => import('pages/back-office/content-management/contact-us'))

const contentContactUsRoutes: IRoute[] = [
  {
    path: CONTENT_URL.CONTACT_US,
    component: ContentContactUsIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: CONTENT_MODULE,
      requireAuth: true,
      attrs: { label: 'contentManagementContactUs.contactUs.contactUs', accessCodes: [558] },
    },
  },
]

export { contentContactUsRoutes }
